import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoXClose = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>XClose</title>
    <path d="m8 8.992 16 16M24 8.987l-16 16" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoXClose;
